import { useContext } from "react";
import { mainContext } from "@ts/constants";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import {
    dateRanges,
    onDateChangeHandler,
    onCustomDateChangeHandler,
    getSelectableDateRange,
} from "@ts/date-range";
import { CUSTOM_DATE_RANGE_LABEL } from "@ts/constants";
import { setPortfoliosData } from "@features/gridDataSlice";
import { useDispatch } from "react-redux";
import { IDRange, IMainContext } from "@ts/common-types";
import { FaCalendarAlt, FaCaretDown } from "react-icons/fa";

interface IPicker {
    chosenLabel: IDRange;
    startDate: Date;
    endDate: Date;
}

const DatePicker = () => {
    const { rulesSummaryDisp, setRuleLogsDate, setDates, setDateRange } =
        useContext<IMainContext>(mainContext) || {};
    const dispatch = useDispatch();
    const lastDateRange: IDRange | string =
        sessionStorage.getItem("lastDateRange");
    const defaultDateRange: IDRange | string = lastDateRange || "Last 7 Days";
    const lastCustomDate = JSON.parse(sessionStorage.getItem("date"));
    const startDate =
        lastDateRange === CUSTOM_DATE_RANGE_LABEL
            ? moment(lastCustomDate.startDate)
            : dateRanges[defaultDateRange][0];
    const endDate =
        lastDateRange === CUSTOM_DATE_RANGE_LABEL
            ? moment(lastCustomDate.endDate)
            : dateRanges[defaultDateRange][1];

    const label =
        startDate.format("DD-MMM-YY") + " - " + endDate.format("DD-MMM-YY");

    return (
        <>
            <DateRangePicker
                initialSettings={{
                    startDate: startDate,
                    endDate: endDate,
                    ranges: {
                        Today: [moment(), moment()],
                        Yesterday: [
                            moment().subtract(1, "days"),
                            moment().subtract(1, "days"),
                        ],
                        "Last 3 Days": [
                            moment().subtract(3, "days"),
                            moment().subtract(1, "days"),
                        ],
                        "Last 7 Days": [
                            moment().subtract(7, "days"),
                            moment().subtract(1, "days"),
                        ],
                        "Last Week": [
                            moment().subtract(1, "week").startOf("week"),
                            moment().subtract(1, "week").endOf("week"),
                        ],
                        "Last 14 Days": [
                            moment().subtract(14, "days"),
                            moment().subtract(1, "days"),
                        ],
                        "Last 30 Days": [
                            moment().subtract(30, "days"),
                            moment().subtract(1, "days"),
                        ],
                        "Current Month": [
                            moment().startOf("month"),
                            moment().endOf("month"),
                        ],
                        "Last Month": [
                            moment().subtract(1, "month").startOf("month"),
                            moment().subtract(1, "month").endOf("month"),
                        ],
                    },
                    ...getSelectableDateRange(),
                }}
                onApply={async (ev, picker: IPicker | any) => {
                    dispatch(setPortfoliosData([]));
                    setDateRange(picker.chosenLabel);
                    if (rulesSummaryDisp) {
                        setRuleLogsDate({
                            startDate: picker.startDate,
                            endDate: picker.endDate,
                        });
                    } else {
                        if (picker.chosenLabel === CUSTOM_DATE_RANGE_LABEL) {
                            onCustomDateChangeHandler(
                                picker.startDate,
                                picker.endDate
                            );
                            setDates((prev: number) => prev + 1);
                        } else {
                            await onDateChangeHandler(picker.chosenLabel);
                        }
                    }
                }}
            >
                <div
                    id="reportrange"
                    className="btn btn-sm btn-light border btn btn-opacity"
                    style={{
                        opacity: "unset",
                        pointerEvents: "unset",
                        padding:'5.5px'
                    }}
                >
                    <FaCalendarAlt style={{transform: "translateY(-10%)"}} className="d-none d-md-inline-block" />
                    &nbsp;
                    <span>{label}</span> <FaCaretDown style={{transform: "translateY(-10%)"}}/>
                </div>
            </DateRangePicker>
        </>
    );
};

export default DatePicker;
